import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Col, Form, Row
} from 'reactstrap';
import CustomAlert from "../Alert/CustomAlert";

const ENTER = 'Enter';

const CustomForm = (props) => {
  const { form, validations, validationMessages, formControls, onSubmit } = props;
  const [formErrors, setFormErrors] = useState([]);

  const handleSave = (e) => {
    e.preventDefault();
    const validatedKeys = Object.keys(validations).map((validation) => {
      return {
        key: validation,
        valid: validations[validation](form)
      };
    });

    if (validatedKeys.every(validation => validation.valid)) {
      setFormErrors([]);
      onSubmit();
    } else {
      setFormErrors(validatedKeys.filter(val => !val.valid).map(val => validationMessages[val.key]));
    }
  };

  const renderCustomAlert = () => {
    if (formErrors?.length > 0) {
      return (
        <CustomAlert type="warning" message={formErrors} />
      );
    }
  };

  const onEnter = (e) => {
    if (e.key === ENTER) handleSave(e);
  };

  return (
    <Form className="custom-form" onSubmit={handleSave} onKeyDown={onEnter}>
      {renderCustomAlert(formErrors)}
      {props.children}
      <div className="form-controls">
        <Row>
          {
            formControls.map((control, index) => {
              return (
                <Col key={`FormControl_${index}`} xs={`${parseInt(12/formControls.length)}`}>
                  <Button
                    block
                    {...control.props}>
                    {control.title}
                  </Button>
                </Col>
              );
            })
          }
        </Row>
      </div>
    </Form>
  );
};

CustomForm.propTypes = {
  form: PropTypes.object.isRequired,
  validations: PropTypes.object,
  validationMessages: PropTypes.object,
  formControls: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    props: PropTypes.object.isRequired
  })).isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default CustomForm;
